// extracted by mini-css-extract-plugin
module.exports = {"primary":"MultiLineText_primary__2zrf8","secondary":"MultiLineText_secondary__umEMq"};